var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgLibrary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1849 3.32005C14.6468 3.44428 14.3112 3.98124 14.4355 4.51937L17.8701 19.3962C17.9943 19.9344 18.5313 20.2699 19.0694 20.1457L19.9249 19.9482C20.4631 19.8239 20.7986 19.287 20.6743 18.7488L17.2397 3.87195C17.1155 3.33382 16.5786 2.99829 16.0404 3.12253L15.1849 3.32005ZM9.64004 4C9.64004 3.44772 10.0878 3 10.64 3L11.5181 3C12.0704 3 12.5181 3.44771 12.5181 4L12.5181 19.2682C12.5181 19.8205 12.0704 20.2682 11.5181 20.2682L10.64 20.2682C10.0878 20.2682 9.64004 19.8205 9.64004 19.2682L9.64004 4ZM3.88404 4C3.88404 3.44772 4.33175 3 4.88404 3L5.76207 3C6.31436 3 6.76207 3.44771 6.76207 4L6.76207 19.2682C6.76207 19.8205 6.31436 20.2682 5.76207 20.2682L4.88404 20.2682C4.33175 20.2682 3.88404 19.8205 3.88404 19.2682L3.88404 4Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgLibrary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/library.160922dbffbcf9f55ffb8b6374f7a7da.svg";